import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, CardTitle, Spinner, Badge } from "reactstrap";
import { Link } from "react-router-dom";
import ApexRadial from "./ApexRadial";

const MonthlyEarning = () => {
  const [earningData, setEarningData] = useState({
    total: 0,
    percentage: 0,
    isLoading: true
  });

  // Rol kontrolünü en üstte yapıyoruz ki UI tarafında da kullanabilelim
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = authUser?.HESAP_TURU === 'Admin';

  useEffect(() => {
    const fetchMonthlyEarnings = async () => {
      try {
        const userId = authUser?.ID;

        // Kullanıcı ID'si yoksa durdur
        if (!userId) {
          console.warn("Kazanç hesabı için Kullanıcı ID bulunamadı.");
          setEarningData(prev => ({ ...prev, isLoading: false }));
          return;
        }

        // Mevcut ayın başlangıcını OData'nın anlayacağı ISO formatında alalım
        const now = new Date();
        const firstDayOfMonth = new Date(Date.UTC(now.getFullYear(), now.getMonth(), 1)).toISOString();

        // ÇÖZÜM: Admin ise herkesi, sürücü ise sadece kendini filtrele
        const filterStr = isAdmin
          ? `$filter=OLUSTURMA_TARIHI ge ${firstDayOfMonth}`
          : `$filter=KIMDEN_ID eq ${userId} and OLUSTURMA_TARIHI ge ${firstDayOfMonth}`;

        const response = await fetch(
          `https://harmanagelapi.stechomeyazilim.info/ILANLAR?${filterStr}&$select=FIYAT`
        );
        const result = await response.json();

        if (result && result.value) {
          const monthlyTotal = result.value.reduce((acc, curr) => acc + (parseFloat(curr.FIYAT) || 0), 0);
          
          setEarningData({
            total: monthlyTotal,
            percentage: 12.5, // Burası ileride önceki ayla kıyaslanarak dinamikleşebilir
            isLoading: false
          });
        } else {
          setEarningData(prev => ({ ...prev, isLoading: false }));
        }
      } catch (error) {
        console.error("Kazanç verisi çekilemedi:", error);
        setEarningData(prev => ({ ...prev, isLoading: false }));
      }
    };

    fetchMonthlyEarnings();
  }, [isAdmin, authUser?.ID]);

  return (
    <React.Fragment>
      <Card className="shadow-sm border-0">
        <CardBody>
          <div className="d-flex justify-content-between align-items-start mb-4">
            {/* Başlığı role göre dinamik yapıyoruz */}
            <CardTitle className="mb-0">
              {isAdmin ? "Sistem Aylık Cirosu" : "Aylık Kazancım"}
            </CardTitle>
            {isAdmin && <Badge color="primary" pill>Yönetici Görünümü</Badge>}
          </div>
          
          <Row>
            <Col sm="6">
              <p className="text-muted mb-1">Bu Ay Toplam</p>
              <h3 className="mb-3">
                {earningData.isLoading ? (
                  <Spinner size="sm" color="primary" />
                ) : (
                  `${earningData.total.toLocaleString("tr-TR")} TL`
                )}
              </h3>
              <p className="text-muted">
                <span className="text-success me-2">
                  {earningData.percentage}% <i className="mdi mdi-arrow-up"></i>
                </span>
                Önceki döneme göre
              </p>

              <div className="mt-4">
                <Link
                  to="/ecommerce-orders"
                  className="btn btn-primary waves-effect waves-light btn-sm btn-rounded"
                >
                  Detayları Gör <i className="mdi mdi-arrow-right ms-1"></i>
                </Link>
              </div>
            </Col>
            <Col sm="6">
              <div className="mt-4 mt-sm-0">
              <ApexRadial 
  dataColors='["--bs-primary"]' 
  value={earningData.percentage} 
  label={isAdmin ? "Sistem Büyümesi" : "Aylık Hedef"} 
/>
              </div>
            </Col>
          </Row>
          <p className="text-muted mb-0 mt-3 small">
            {isAdmin 
              ? "Sistem üzerinden bu ay oluşturulan tüm ilanların toplam bedelidir." 
              : "Bu ay size atanan ve tamamlanan tüm taşımaların toplam bedelidir."}
          </p>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default MonthlyEarning;